import request from '@/utils/request';
import { MAXPLUS_PLAN_PREMIUM_NAME } from '@/store/models/wallet';
import { fetchCurrentUser } from '@/store/actions/currentUser.actions';

export const MANAGEABLE_USERS = 'MANAGEABLE_USERS';

export const fetchManageableUsers = () => async dispatch => {
  const response = await request({
    path: `/v1/max_plus_subscriptions/manageable_users`
  });
  dispatch({
    payload: response,
    type: MANAGEABLE_USERS
  });
};

export const subscribeMaxPlus =
  ({ plan = MAXPLUS_PLAN_PREMIUM_NAME } = {}) =>
  async dispatch => {
    const response = await request({
      path: `/v1/max_plus_subscriptions`,
      method: 'POST',
      body: { payment_type: 'credit_card', plan }
    });
    await dispatch(fetchCurrentUser());
    return response;
  };

export const cancelMaxPlus = () => async dispatch => {
  const response = await request({
    path: `/v1/max_plus_subscriptions/cancel`,
    method: 'POST'
  });
  await dispatch(fetchCurrentUser());
  return response;
};

export const cancelForUserMaxPlus = userId => async () => {
  const response = await request({
    path: `/v1/max_plus_subscriptions/cancel_for_user`,
    method: 'POST',
    body: { user_id: userId }
  });
  return response;
};

export const bulkSubscribeMaxPlus =
  (userIds = [], plan = MAXPLUS_PLAN_PREMIUM_NAME) =>
  async dispatch => {
    const response = await request({
      path: `/v1/max_plus_subscriptions/bulk_subscribe`,
      method: 'POST',
      body: { user_ids: userIds, plan }
    });
    await dispatch(fetchCurrentUser());
    return response;
  };
